/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_ADMIN_CASHIER } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAdminCashierMethods extends IPluginMethodMap {
    getAdminCashierProps(args: any): Promise<any>;
}

export class AdminCashierService implements IAgentPlugin {
    readonly methods: IAdminCashierMethods;

    constructor() {
        this.methods = {
            getAdminCashierProps: this.getAdminCashierProps.bind(this),
        };
    }

    async getAdminCashierProps(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ADMIN_CASHIER,
                    variables: {
                        input: {
                            where: [
                                {
                                    column: "role",
                                    op: "In",
                                    value: [
                                        "fe93dab0-424b-4aa3-9efa-c001b4c03013",
                                        "f5bebfee-dc0a-460a-9a3f-c6cde8fed944"
                                    ]
                                }
                            ],

                        }
                    },
                    fetchPolicy: "network-only",
                });

                if (res?.data) {
                    return {
                        AdminCashierFilter: res?.data?.getUserList?.data?.map(
                            (_item: any) => {
                                return { value: _item?.email, label: _item?.fullName==="" ? _item?.email : _item?.fullName };
                            }
                        ),
                    };
                }
            }
        } catch (err: any) {
            console.log(`error in table data`, err);
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }
}
